// import GenericButton from "@ui-components/Button/GenericButton";
import GenericCard from "@ui-components/Card/GenericCard";
import React from "react";
// import { ReactComponent as AddServiceIcon } from "../../../shared/assets/Icons/IconPlusNV.svg";
import { ReactComponent as SearchIcon } from "../assets/Icons/IconsSearch.svg";
import { ReactComponent as HomeSvg } from "../assets/Icons/Icon.svg";
import { useLocation } from "react-router-dom";

interface EmptyItems {
  text: string;
}
interface RouteConfig {
  message: string;
  buttonLabel: string;
  targetRoute: string;
  icon: React.ReactNode;
}

// Map each route to its corresponding configuration.
const routeConfigs: Record<string, RouteConfig> = {
  "/kontrol/datacenter": {
    message: "You have no Datacenter Interconnect yet",
    buttonLabel: "Add New DCI",
    targetRoute: "/kontrol/add-dc",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/port": {
    message: "You have no Ports yet",
    buttonLabel: "Add New Port",
    targetRoute: "/kontrol/add-port",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/ipx": {
    message: "You have no Internet Connection yet",
    buttonLabel: "Add New Internet Connection",
    targetRoute: "/kontrol/add-ipx",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/cloud-connectivity": {
    message: "You have no Cloud Connectivity yet",
    buttonLabel: "Add New Cloud Connectivity",
    targetRoute: "/kontrol/add-cc",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/backbone": {
    message: "You have no Backbone yet",
    buttonLabel: "Add New Backbone",
    targetRoute: "/kontrol/add-backbone",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol": {
    message: "You have no analytics data in your dashboard.",
    buttonLabel: "Add New Services",
    targetRoute: "/kontrol",
    icon: <HomeSvg className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/management/clusters": {
    message: "You have no Clusters yet",
    buttonLabel: "Add New Cluster",
    targetRoute: "/reflector-v2/management/clusters/add",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/management/bgp-reflectors": {
    message: "You have no Reflectors yet",
    buttonLabel: "Add New Reflector",
    targetRoute: "/reflector-v2/management/bgp-reflectors/add",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/management/cloud-propagation": {
    message: "You have no Cloud Propagation Neighbors yet",
    buttonLabel: "Add New Cloud Propagation Neighbor",
    targetRoute: "/reflector-v2/management/cloud-propagation/add",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/management/bgp": {
    message: "You have no BGP Neighbors yet",
    buttonLabel: "Add New BGP Neighbor",
    targetRoute: "/reflector-v2/management/bgp/add",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/overview": {
    message: "You have no Data yet",
    buttonLabel: "Add New Data",
    targetRoute: "/reflector-v2/overview",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/reflector-v2/management/bgp-visibility": {
    message: "You have no BGP Configurations yet",
    buttonLabel: "Add New BGP Configuration",
    targetRoute: "/reflector-v2/management/bgp-visibility",
    icon: <SearchIcon className="h-10 w-10 text-semantic-text-secondary"/>
  }
};

const EmptyItems: React.FC = () => {
  // const navigate = useNavigate();
  const location = useLocation();

  function getRouteConfig(pathname: string) {
    // Try exact match first
    if (routeConfigs[pathname]) return routeConfigs[pathname];
    // Try startsWith for dynamic routes
    const match = Object.keys(routeConfigs).find((key) =>
      pathname.startsWith(key)
    );
    return match ? routeConfigs[match] : null;
  }

  const currentConfig = getRouteConfig(location.pathname);
  // const handleNavigation = () => {
  //   if (currentConfig) {
  //     navigate(currentConfig.targetRoute);
  //   } else {
  //     console.warn("No target route defined for", location.pathname);
  //   }
  // };

  return (
    <div className="min-h-[calc(100vh-10rem)] flex items-center justify-center">
      <div className="w-1/2">
        <GenericCard
          isCollapsible={false}
          bodyContent={
            <div className="flex flex-col items-center justify-center text-center space-y-4 p-6">
              <div className="bg-semantic-bg-secondary inline-flex items-center justify-center border rounded-md p-2">
                {currentConfig ? currentConfig.icon : ''}
              </div>
              {/* Dynamic message */}
              <h3 className="text-1xl font-bold">
                {currentConfig ? currentConfig.message : "No items found"}
              </h3>
              <p className="text-sm text-semantic-text-secondary" >
                Your tenant is currently empty. To add new services, contact your account manager.
              </p>
              {/* <GenericButton
                label={currentConfig ? currentConfig.buttonLabel : "Add New Item"}
                variant="brand"
                size="sm"
                disabled={isDisabled}
                icon={<AddServiceIcon className="h-5 w-5 text-semantic--color-primitive-base-white" />}
                onClick={handleNavigation}
              /> */}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default EmptyItems;